<template>
  <b-modal id="bv-modal-choose-type" centered hide-footer @show="clearInfo()">
    <template #modal-title>
      {{ $t("project.activity.create_activity_header_text") }}
    </template>
    <template v-slot:modal-header-close>
      <i class="fa fa-close">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.4856 0.290709L17.6041 0.39587C17.8383 0.630061 17.9783 0.942035 17.9977 1.27262C18.0171 1.6032 17.9144 1.9294 17.7093 2.18935L17.6041 2.3079L10.912 9L17.6041 15.6921C17.8383 15.9263 17.9783 16.2383 17.9977 16.5689C18.0171 16.8994 17.9144 17.2256 17.7093 17.4856L17.6041 17.6041C17.3699 17.8383 17.058 17.9783 16.7274 17.9977C16.3968 18.0171 16.0706 17.9144 15.8106 17.7093L15.6921 17.6041L9 10.912L2.3079 17.6041C2.07371 17.8383 1.76173 17.9783 1.43115 17.9977C1.10057 18.0171 0.774363 17.9144 0.514415 17.7093L0.39587 17.6041C0.161741 17.3699 0.0217041 17.058 0.00232013 16.7274C-0.0170638 16.3968 0.0855526 16.0706 0.290707 15.8106L0.39587 15.6921L7.08797 9L0.39587 2.3079C0.161741 2.07371 0.0217036 1.76173 0.00231968 1.43115C-0.0170643 1.10057 0.0855535 0.774364 0.290708 0.514415L0.39587 0.39587C0.63006 0.161741 0.942035 0.0217036 1.27262 0.00231968C1.6032 -0.0170642 1.9294 0.0855532 2.18935 0.290708L2.3079 0.39587L9 7.08797L15.6921 0.39587C15.9263 0.161741 16.2383 0.0217038 16.5688 0.00231991C16.8994 -0.017064 17.2256 0.0855537 17.4856 0.290709Z" fill="#303C54"/>
        </svg>
      </i>
    </template>
    <ValidationObserver ref="formKickOffAndBonus" @submit.prevent="addKickOffAndBonus">
      <div class="create-content">
        <div class="type">
          <span class="create-content-heading">{{ $t("project.activity.activity_type") }}<span class="required"> *</span></span>
          <ValidationProvider
            v-slot="{ errors }"
            mode="passive"
            name="activity.activity_type"
            rules="required"
          >
            <multiselect
              v-model="formData.type"
              :close-on-select="true"
              :options="typeList"
              :searchable="false"
              :show-labels="false"
              deselectLabel=""
              :placeholder="$t('project.activity.activity_select_placeholder')"
              selectLabel=""
              selectedLabel=""
              :allowEmpty="false"
            />
            <span v-if="formData.type === null" class="error">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div v-if="formData.type !== null" class="info">
          <div class="info-content">
            <span class="create-content-heading">{{ $t("project.activity.activity_date") }} <span class="required"> *</span></span>
            <ValidationProvider
              v-slot="{ errors }"
              mode="passive"
              :name="$t('project.activity.error.time')"
              rules="required"
            >
              <date-picker
                v-model="formData.date" format="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                type="date"
                value-type="format"
                :disabled-date="(date) => date < startDate || date > endDate"
                :default-value="startDate"
              >
                <i slot="icon-calendar">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.9997 2.66602H3.99967C2.52692 2.66602 1.33301 3.85992 1.33301 5.33268V11.9993C1.33301 13.4721 2.52692 14.666 3.99967 14.666H11.9997C13.4724 14.666 14.6663 13.4721 14.6663 11.9993V5.33268C14.6663 3.85992 13.4724 2.66602 11.9997 2.66602Z" stroke="#303C54" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M5.33301 1.33301V3.99967" stroke="#303C54" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M10.666 1.33301V3.99967" stroke="#303C54" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M1.33301 6.66602H14.6663" stroke="#303C54" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </i>
              </date-picker>
              <span v-if="formData.date === null" class="error">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div
            v-if="typeList.indexOf(formData.type) === 4 || typeList.indexOf(formData.type) === 3"
          >
            <div
              v-for="(employee, index) of formData.employees"
              :key="index"
              :class="{'info-content': typeList.indexOf(formData.type) === 3, 'info-content-bonus': typeList.indexOf(formData.type) === 4}"
            >
              <div class="employee-select">
                  <span class="create-content-heading">
                    {{ $t("project.activity.activity_employee") }}
                    <span class="required"> *</span>
                  </span>
                <ValidationProvider
                  v-slot="{ errors }"
                  mode="passive"
                  :name="$t('project.activity.error.employee')"
                  rules="required"
                  :vid="'employee_' + index"
                >
                  <multiselect
                    v-model="employee.employee"
                    :close-on-select="true"
                    :options="listMember"
                    :searchable="false"
                    :show-labels="false"
                    deselectLabel=""
                    :placeholder="$t('project.activity.activity_select_placeholder')"
                    selectLabel=""
                    selectedLabel=""
                    track-by="employee_id"
                    label="name"
                  />
                  <span v-if="employee.employee === null || employee.employee.name === ''" class="error">{{ errors[0] }}</span>
                  <span
                    v-if="employee.employee !== null && formData.employees.length > 1 && !isEmployeeUnique(employee.employee)"
                    class="error unique"
                  >
                      {{ $t('project.activity.activity_unique_employee_error_message') }}
                    </span>
                </ValidationProvider>
              </div>
              <div v-if="typeList.indexOf(formData.type) === 4" class="employee-bonus-input">
                  <span class="create-content-heading">{{ $t("project.activity.activity_employee_amount") }} ({{ $t("project.activity.activity_currency") }})
                    <span class="required"> *</span>
                  </span>
                <ValidationProvider
                  v-slot="{ errors }"
                  :rules="{
                    required: true,
                    numeric: true,
                  }"
                  mode="passive"
                  :name="$t('project.activity.error.bonus')"
                  :vid="'bonus_' + index"
                >
                  <div class="amount-component">
                    <input
                      v-model="employee.amount"
                      class="total-amount-number"
                      onkeypress="return (event.charCode === 8 || event.charCode === 0 || event.charCode === 13) ? null : event.charCode >= 48 && event.charCode <= 57"
                      type="number"
                      :placeholder="$t('project.activity.activity_input_amount')"/>
                    <div v-if="typeList.indexOf(formData.type) === 4" class="remove-employee-button">
                      <div class="remove-employee-icon" @click="removeEmployee(index)" v-if="formData.employees.length > 1">
                        <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="15.5" cy="15.5" r="15.5" fill="#F1F1F1"/>
                          <path d="M21.22 16.5208H9.78008C9.34922 16.5208 9 16.0641 9 15.5006C9 14.9371 9.34911 14.4805 9.78008 14.4805H21.22C21.6508 14.4806 22 14.9373 22 15.5007C22 16.0641 21.6508 16.5208 21.22 16.5208Z" fill="#514C4C"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <span
                    v-if="employee.amount === null || employee.amount === '' || !isNumeric(employee.amount)"
                    class="error">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

          </div>
          <div v-if="typeList.indexOf(formData.type) === 4 && formData.employees.length < listMember.length" class="add-employee-button">
            <div class="add-employee-icon" @click="addEmployee()">
              <svg fill="none" height="13" viewBox="0 0 13 13" width="13" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M6.5 0.125C6.71134 0.125 6.91403 0.208956 7.06348 0.358399C7.21292 0.507842 7.29688 0.710531 7.29688 0.921875V5.70312H12.0781C12.2895 5.70312 12.4922 5.78708 12.6416 5.93652C12.791 6.08597 12.875 6.28866 12.875 6.5C12.875 6.71134 12.791 6.91403 12.6416 7.06348C12.4922 7.21292 12.2895 7.29688 12.0781 7.29688H7.29688V12.0781C7.29688 12.2895 7.21292 12.4922 7.06348 12.6416C6.91403 12.791 6.71134 12.875 6.5 12.875C6.28866 12.875 6.08597 12.791 5.93652 12.6416C5.78708 12.4922 5.70312 12.2895 5.70312 12.0781V7.29688H0.921875C0.710531 7.29688 0.507842 7.21292 0.358399 7.06348C0.208956 6.91403 0.125 6.71134 0.125 6.5C0.125 6.28866 0.208956 6.08597 0.358399 5.93652C0.507842 5.78708 0.710531 5.70312 0.921875 5.70312H5.70312V0.921875C5.70312 0.710531 5.78708 0.507842 5.93652 0.358399C6.08597 0.208956 6.28866 0.125 6.5 0.125Z"
                  fill="#514C4C"/>
              </svg>
            </div>
            <span class="add-employee-text">{{ $t("project.activity.activity_add_employee") }}</span>
          </div>
          <div v-if="typeList.indexOf(formData.type) === 3" class="info-content">
            <span class="create-content-heading">{{ $t("project.activity.activity_employee_amount") }} ({{ $t("project.activity.activity_currency") }})<span class="required"> *</span></span>
            <ValidationProvider
              v-slot="{ errors }"
              mode="passive"
              :name="$t('project.activity.error.total_bonus')"
              rules="required|numeric|max_value:2147483647"
            >
              <input
                type="number"
                v-model="formData.budget"
                class="total-amount-number"
                onkeypress="return (event.charCode === 8 || event.charCode === 0 || event.charCode === 13) ? null : event.charCode >= 48 && event.charCode <= 57"
                :placeholder="$t('project.activity.activity_input_amount')"
                required
              />
              <span
                v-if="formData.budget === null || formData.budget === '' || !isNumeric(formData.budget) || formData.budget > 2147483647"
                class="error"
              >
                    {{ errors[0] }}
                  </span>
            </ValidationProvider>
          </div>
          <div v-if="typeList.indexOf(formData.type) === 6" class="info-content">
            <span class="create-content-heading">{{ $t("project.activity.activity_title_text") }}<span class="required"> *</span></span>
            <ValidationProvider
              v-slot="{ errors }"
              mode="passive"
              :name="$t('project.activity.activity_title_text')"
              rules="required"
            >
              <input v-model="formData.title" class="input-text" :placeholder="$t('project.activity.activity_title_placeholder_text')" required/>
              <span
                v-if="formData.title === null || formData.title === ''"
                class="error"
              >
                    {{ errors[0] }}
                  </span>
            </ValidationProvider>
          </div>
          <div class="info-content" v-if="typeList.indexOf(formData.type) === 0 || typeList.indexOf(formData.type) === 5">
            <span class="create-content-heading">{{ $t("project.activity.activity_file") }} <span class="required"> *</span></span>
            <ValidationProvider
              v-slot="{ validate, errors }"
              mode="passive"
              rules="required"
              :name="$t('project.activity.error.file')"
              ref="fileProvider"
            >
              <input
                id="upload-file-input"
                ref="inputFile"
                type="file"
                @change="handleFileUpload($event)"
                hidden
              >
              <div class="upload-button" @click="uploadFile()">
                <img src="/img/icons/upload-icon.svg" alt="My Happy SVG"/>
                <span class="upload-text">
                {{$t("project.activity.activity_upload_file_text")}}
              </span>
              </div>
              <span
                v-if="!file"
                class="error"
              >
                    {{ errors[0] }}
                  </span>
            </ValidationProvider>
              <div class="upload-file-list" v-if="file">
                <div class="file">
                  <div class="file-name">
                    <span>{{ file.name }}</span>
                  </div>
                  <button
                    type="button"
                    class="btn-delete"
                    @click="removeFile"
                  >
                    {{$t("project.activity.activity_remove_file_button_text")}}
                  </button>
                </div>
              </div>
            <span
              v-if="errorFile"
              class="error"
            >
                    {{errorFile}}
            </span>
          </div>
          <div class="info-content">
            <span class="create-content-heading">{{ $t("project.activity.activity_upload_image_header_text") }} <span class="required"> *</span></span>
            <ValidationProvider
              v-slot="{ validate, errors }"
              mode="passive"
              rules="required"
              :name="$t('project.activity.error.image')"
              ref="imageProvider"
            >
              <input
                id="upload-image-input"
                ref="inputImage"
                type="file"
                multiple
                @change="handleImageUpload($event)"
                hidden
              >
              <div class="upload-button" @click="uploadImages()">
                <img src="/img/icons/upload-icon.svg" alt="My Happy SVG"/>
                <span class="upload-text">
                {{$t("project.activity.activity_upload_image_text")}}
              </span>
              </div>
              <span
                v-if="images.length < 1"
                class="error"
              >
                    {{ errors[0] }}
                  </span>
            </ValidationProvider>
            <div class="upload-image-list">
              <div
                v-for="(item, key) of images"
                :key="'file upload' + key"
                class="file"
              >
                <figure>
                  <img
                    :src="item.file_url"
                  />
                </figure>
                <button
                  type="button"
                  class="btn-delete"
                  @click="removeImage(key)"
                >
                  {{$t("project.activity.activity_remove_image_button_text")}}
                </button>
              </div>
            </div>
            <span
              v-if="errorImage"
              class="error"
            >
                    {{errorImage}}
                  </span>
          </div>
          <div class="info-content">
            <span class="create-content-heading">{{ $t("project.activity.activity_note") }}</span>
            <ValidationProvider
              v-slot="{ errors }"
              mode="passive"
            >
            <textarea
              v-model="formData.note"
              class="note-input"
              name="note"
              :placeholder="$t('project.activity.activity_note_placeholder')"
            />
              <span
                class="error"
              >
                    {{ errors[0] }}
                  </span>
            </ValidationProvider>
          </div>
        </div>
      </div>
      <div class="create-kick-off-bonus-footer">
        <button class="confirm-button" @click="addKickOffAndBonus">
          {{ $t("project.activity.activity_button_submit") }}
        </button>
        <button class="cancel-button" @click="$bvModal.hide('bv-modal-choose-type')">
          {{ $t("project.activity.activity_button_cancel") }}
        </button>
      </div>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import {ValidationObserver, ValidationProvider} from "vee-validate";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "CreateActivityModal",
  components: {
    DatePicker,
    Multiselect,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      formData: {
        type: null,
        date: null,
        budget: null,
        employees: [
          {employee: null},
        ],
        title: null,
        note: ''
      },
      error: [],
      file: null,
      images: [],
      errorImage: null,
      errorFile: null,
    }
  },
  computed: {
    ...mapGetters({
      listProjectMember: "project/listProjectMember",
      account: "auth/account",
      project: "project/project",
      locale: "lang/locale",
    }),

    listMember() {
      return this.listProjectMember;
    },
    employeeFormat: {
      get(){
        return this.formData.employees.map(item => {
          if (item.employee) {
            item.employee['amount'] = item['amount']
          }
          return item.employee
        })
      },
      set(newValue){
        return newValue
      }
    },
    typeList() {
      return [
        this.$t("project.activity.meeting_activity"),
        this.$t("project.activity.party_activity"),
        this.$t("project.activity.team_building"),
        this.$t("project.activity.hot_bonus_text"),
        this.$t("project.activity.project_bonus_text"),
        this.$t("project.activity.meeting_close_project"),
        this.$t("project.activity.other_text"),
      ]
    },
    listMemberArr() {
      return this.listMember;
    },
    formType() {
      return this.formData.type;
    },
    startDate() {
      let date = this.project.start_date.split('/')
      return new Date(date[2], date[1]-1, date[0]);
    },
    endDate() {
      let date = this.project.end_date.split('/')
      return new Date(date[2], date[1]-1, date[0]);
    }
  },
  watch: {
    formType() {
      if (this.formData.employees.length > 0) {
        this.formData.employees = [
          {employee: null}
        ]
      }
      this.formData.date = null;
      this.formData.budget = null;
      this.formData.title = null;
      this.formData.note = '';
      this.images = [];
      this.file = null;
      this.errorImage = null;
      this.errorFile = null;
      if (this.$refs.formKickOffAndBonus) {
        this.$refs.formKickOffAndBonus.reset();
        this.$refs.imageProvider.syncValue(this.images);
        if (this.images.length === 0) {
          this.errorImage = null;
          this.$refs.inputImage.value = this.images;
        }
        if (this.$refs.fileProvider) {
          this.$refs.fileProvider.syncValue(this.file);
          this.$refs.inputFile.value = this.file;
        }
      }
    }
  },
  // created() {
  //   this.$store.dispatch('project/getProjectDetail', this.$route.params.id);
  // },
  methods: {
    ...mapActions("layout", ["setLoading"]),
    clearInfo() {
      this.formData = {
        type: this.$t("project.activity.meeting_activity"),
        date: null,
        budget: null,
        employees: [
          {employee: null}
        ],
        note: '',
        title: null,
      };
      this.errorImage = null;
      this.errorFile = null;
      this.images = [];
      this.file = null;
      if (this.$refs.formKickOffAndBonus) {
        this.$refs.formKickOffAndBonus.reset();
      }
    },
    async addKickOffAndBonus() {
      this.error = [];
      let isFormValid = await this.$refs.formKickOffAndBonus.validate();
      let employeeArr = this.employeeFormat.filter(item => item !== null);
      // Validate unique employee
      if (this.employeeFormat.filter(item => item !== null).length > 0) {
        const uniqueValues = new Set(this.employeeFormat.filter(item => item !== null).map(v => v.employee_id));
        if (uniqueValues.size < this.employeeFormat.length) {
          this.error['unique_employee'] = this.$t('project.activity.activity_unique_employee_error_message')
        }
      }

      if (!isFormValid || Object.keys(this.error).length || this.images.length < 1 && this.errorImage || this.errorFile) {
        return false;
      }
      this.setLoading(true);
      if (this.typeList.indexOf(this.formData.type) === 3) {
        this.formData.employees[0].employee.amount = this.formData.budget;
      } else {
        for (let employee of employeeArr) {
          employee['create_by'] = this.account.name;
          employee['update_by'] = this.account.name;
          employee['amount'] = employee['amount'] ?? null;
        }
      }
      let params = new FormData();
      if (this.formData.date) {
        let date = this.formData.date.split(' ').reverse().join(' ').replaceAll('/', '-');
        params.append('date', date);
      }
      if (this.file) {
        params.append('document_file', this.file);
      }
      for( let i = 0; i < this.images.length; i++ ){
        let image = this.images[i];
        params.append('images[' + i + ']', image);
      }
      let employeeId = employeeArr.map(item => item.employee_id)
      let employeeAmount = employeeArr.map(item => item.amount)
      if (employeeId.length > 0) {
        params.append('employeeId', JSON.stringify(employeeId));
      }
      if (employeeAmount.length > 0) {
        params.append('employeeAmount', JSON.stringify(employeeAmount));
      }
      params.append('project_id', this.$route.params.id);
      params.append('title', this.formData.title ? this.formData.title : this.formData.type);
      params.append('type', this.typeList.indexOf(this.formData.type));
      if (this.formData.budget) {
        params.append('budget', this.formData.budget);
      }
      params.append('create_by', this.account.name);
      params.append('update_by', this.account.name);
      params.append('note', this.formData.note);
      await this.$store.dispatch("project/createActivity", params);
      await this.$store.dispatch('project/getListKickOffBonus', this.$route.params.id);
      await this.$bvModal.hide('bv-modal-choose-type');
      let message = this.$t("project.activity.activity_toast_success_message");
      let title = this.$t("project.activity.activity_toast_success_title");
      await this.$toast(message, title, 2000, "b-toaster-top-center", "success");
      this.setLoading(false);
      // if (check && !isDuplicate) {
      //
      // } else {
      //   // let message = this.$t("project.activity.activity_toast_fail_message");
      //   // let title = this.$t("project.activity.activity_toast_fail_title");
      //   // await this.$toast(message, title, 2000, "b-toaster-top-center", "danger");
      //   console.log('error: ', check)
      //   this.$root.$loading.finish();
      // }
    },
    addEmployee() {
      if (this.listMember.length > 0 && this.formData.employees.length < this.listMember.length) {
        this.formData.employees.push({employee: null})
      }
    },
    removeEmployee(index) {
      if (this.formData.employees.length > 1) {
        this.formData.employees.splice(index, 1);
      }
    },
    isNumeric(string) {
      return (typeof(string) === 'number' || typeof(string) === "string" && string.trim() !== '') && !isNaN(string);
    },
    isEmployeeUnique(employee) {
      if (employee && this.formData.employees.length > 1) {
        let sameEmployees = this.employeeFormat.filter(item => item !== null && item.employee_id === employee.employee_id);
        return sameEmployees.length < 2;
      }
    },
    isEmployeeSelected(employeeId){
      return this.employeeFormat.some(item => item.employee_id === employeeId)
    },
    uploadImages() {
      let uploadInput = document.getElementById('upload-image-input');
      uploadInput.click();
    },
    uploadFile() {
      let uploadInput = document.getElementById('upload-file-input');
      uploadInput.click();
    },
    async handleFileUpload(event) {
      const { valid } = await this.$refs.fileProvider.validate(event);
      this.errorFile = null;
      if (valid) {
        if (!this.validateInputFile(event.target.files)) {
          this.file = null;
          return;
        }
        this.file = event.target.files[0];
        this.$refs.inputFile.value = '';
      }
      this.$refs.fileProvider.reset();
    },
    async handleImageUpload(event) {
      const { valid } = await this.$refs.imageProvider.validate(event);
      this.errorImage = null;
      if (valid) {
        if (!this.validateInputImage(event.target.files)) {
          return;
        }
        for (let i = 0; i < event.target.files.length; i++) {
          if (!this.images.includes(event.target.files[i])) {
            let file = event.target.files[i];
            this.images.push(file);
          }
        }
        this.getImagePreviews();
        this.$refs.inputImage.value = '';
        // this.$refs.imageProvider.syncValue(this.$refs.inputImage.value);
      }
      this.$refs.imageProvider.reset();
    },
    validateInputImage(files) {
      const maxFile = 5;
      const extensions = ["png", "jpeg", "jpg"];
      const maxSize = 25;
      if (files.length > maxFile || (this.images.length + files.length) > maxFile) {
        this.errorImage = this.$t("project.activity.activity_input_image_amount_error_message");
        return false;

      } else {
        for (let i = 0; i < files.length; i++) {
          let file = files[i];
          let fileNameExt = file.name.split('.').pop()
          let fileSize = file.size / (1024*1024);

          if (!extensions.includes(fileNameExt.toLowerCase())) {
            this.errorImage = this.$t("project.activity.activity_input_image_file_error_message");
          } else if (fileSize > maxSize) {
            this.errorImage = this.$t("project.activity.activity_input_image_size_error_message");
          }

          if (this.errorImage !== null) {
            return false;
          }
        }
      }

      return true;
    },
    validateInputFile(files) {
      const maxSize = 5;
      // const maxFile = 1;
      const extensions = ["xlsx", "pdf","xls", "csv"];
      // if (files.length > maxFile || files.length > maxFile) {
      //   this.errorFile = this.$t("project.activity.activity_input_file_amount_error_message");
      //   return false;
      // } else {
      //
      // }
      let file = files[0];
      let fileSize = file.size / (1024*1024);
      let fileNameExt = file.name.split('.').pop()

      if (!extensions.includes(fileNameExt.toLowerCase())) {
        this.errorFile = this.$t("project.activity.activity_input_file_type_error_message");
      } else if (fileSize > maxSize) {
        this.errorFile = this.$t("project.activity.activity_input_file_size_error_message");
      }
      return this.errorFile === null;
    },
    getImagePreviews() {
      for (let i = 0; i < this.images.length; i++) {
        if (/\.(jpe?g|png)$/i.test(this.images[i].name)) {
          if (this.isFileInstance(this.images[i])) {
            this.images[i].file_url = URL.createObjectURL(this.images[i]);
          }
        } else {
          this.images[i].file_url = document.getElementById("img-default").src;
        }
      }
      this.loadImages(this.images);
    },
    removeImage(key) {
      this.images.splice(key, 1);
      this.$refs.imageProvider.syncValue(this.images);
      if (this.images.length === 0) {
        this.errorImage = null;
        this.$refs.inputImage.value = this.images;
      }
    },
    removeFile() {
      this.file = null;
      this.errorFile = null;
      this.$refs.fileProvider.syncValue(this.file);
      this.$refs.inputFile.value = this.file;
    },
    loadImages(files) {
      if (files.length > 0) {
        this.setLoading(true);
        for (let i = 0; i < files.length; i++) {
          const img = new Image();
          img.src = files[i].file_url;
          img.onload = () => {
            if (i + 1 === files.length) {
              this.setLoading(false);
            }
          }
          img.onerror = () => {
            if (i + 1 === files.length) {
              this.setLoading(false);
            }
          };
        }
      }
    },
    isFileInstance(file) {
      return file instanceof File;
    },
    renameFile(file, fileName) {
      return new File([file], fileName, {type: file.type})
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .modal-title {
  color: #1F2D3D;
}
.total-amount-number {
  //font-family: 'Roboto', sans-serif;
  //font-style: normal;
  //font-weight: 400;
  //font-size: 14px;
  line-height: 16px;
  color: #303C54;
  padding: 12px 0 12px 14px;
  background: #FFFFFF;
  border: 1px solid #CFCFCF;
  border-radius: 5px;
  width: 100%
}
.total-amount-number::placeholder {
  color: #A5A5A5;
}

.input-text {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #303C54;
  padding: 12px 0 12px 14px;
  background: #FFFFFF;
  border: 1px solid #CFCFCF;
  border-radius: 5px;
  width: 100%
}

.input-text::placeholder {
  color: #A5A5A5;
}

.info-content .input-text {
  outline: none
}

.employee-bonus-input {
  display: flex;
  flex-direction: column;
}

.create-kick-off-bonus-footer {
  display: flex;
  justify-content: center;
  padding-top: 24px;
}

.create-content {
  padding-bottom: 2px;
}

.confirm-button {
  width: 172px;
  height: 49px;
  left: 575px;
  top: 505px;
  background: #118FA6;
  border-radius: 5px;
  font-family: 'Helvetica Neue', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: #EBF3F4;
  outline: none;
  border-width: 0;
  margin-right: 10px;
}

.cancel-button {
  width: 172px;
  height: 49px;
  left: 767px;
  top: 505px;
  background: #FFFFFF;
  border: 1px solid #6E7A8B;
  border-radius: 5px;
  font-family: 'Helvetica Neue', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: #1F2D3D;
  margin-left: 10px;
}

.create-content .type {
  display: flex;
  flex-direction: column;
}

//.create-content .info {
//  padding-top: 12px
//}

.info-content {
  display: flex;
  flex-direction: column;
  padding-top: 12px;
}

//.info-content:first-child {
//  padding-top: 0;
//}

.info-content .total-amount-number {
  outline: none
}

.info-content-bonus {
  display: flex;
  padding-top: 12px;
}

//.info-content-bonus:first-child {
//  padding-top: 0;
//}

.info-content-bonus .total-amount-number {
  outline: none
}

.info-content-bonus .employee-select {
  flex: 9
}

.info-content-bonus .employee-bonus-input {
  flex: 5;
  margin-left: 24px;
}

.create-content-heading {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #303C54;
  padding: 8px 0
}

.add-employee-button {
  display: flex;
  padding-top: 10px;
  align-items: center;
}

.remove-employee-button {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 0 0 6px 20px;
}

.add-employee-icon {
  width: 31px;
  height: 31px;
  background: #F1F1F1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

.remove-employee-icon {
  width: 31px;
  height: 31px;
  background: #F1F1F1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

.add-employee-text {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #303C54;
  padding-left: 8px;
}

.employee-select {
  display: flex;
  flex-direction: column;
}

.mx-datepicker {
  width: 100%;
}

.black-color {
  color: black;
}

/deep/ .multiselect__tags {
  border: 1px solid #CFCFCF;
  border-radius: 5px;
}

/deep/ .multiselect__placeholder {
  padding-left: 4px;
  color: #A5A5A5;
}

/deep/ .mx-icon-calendar {
  color: white;
}
.required {
  color: red
}

.error {
  color: red
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
/deep/ .modal-dialog {
  max-width: 36%;
  width: 36%;
}
.upload-button {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #F8F8F8;
  border: 1px solid #EDEDED;
  border-radius: 20px;
  max-width: 154px;
  width: fit-content;
  height: 32px;
  padding: 6px 14px;
  cursor: pointer;
}
.upload-text {
  padding-left: 6px;
  color: #303C54;
}
.upload-image-list {
  padding-top: 10px;
  width: 100%;
  height: auto;
  display: flex;
}
.upload-image-list .file {
  width: fit-content;
  height: auto;
  margin: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5px 15px;
}
.upload-file-list {
  padding-top: 10px;
}
.upload-file-list .file {
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
}
.upload-file-list .file:first-child {
  padding-top: 0;
}
.upload-image-list .file figure {
  width: 100px;
  height: 100px;
  background: #eee;
  border-radius: 3px;
  margin: 0;
  padding: 1px;
  display: block;
  float: left;
  overflow: hidden;
}
.upload-image-list .file figure img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}
.upload-image-list .file .file-name {
  width: 400px;
  height: 100%;
  margin: 0;
  padding: 0 0 0 10px;
  display: table;
  float: left;
}
.upload-image-list .file .btn-delete {
  width: 50px;
  height: auto;
  color: #999;
  font-size: 10px;
  font-weight: 300;
  line-height: 12px;
  margin: 19px 0;
  padding: 0;
  float: right;
  transition: all .3s;
  border: none;
  outline: none;
}
.upload-file-list .file .btn-delete {
  width: 50px;
  height: auto;
  color: #999;
  font-size: 10px;
  font-weight: 300;
  line-height: 12px;
  padding: 0;
  float: right;
  transition: all .3s;
  border: none;
  outline: none;
}
.note-input {
  width: 100%;
  height: 150px;
  resize: none;
  outline: none;
  background: #FFFFFF;
  border: 1px solid #CFCFCF;
  border-radius: 5px;
  padding: 12px 14px;
}
.amount-component {
  display: flex;
  flex-direction: row;
}
/deep/ .mx-input {
  height: 40px;
}

/deep/ .mx-input::placeholder {
  color: #A5A5A5;
}

/deep/ .multiselect__single {
  color: #303C54;
  font-size: 14px;
}
.note-input::placeholder {
  color: #A5A5A5;
}
/deep/ .employee-select .multiselect__select::before {
  top: 74%;
}
</style>
